import React, {useState, useRef, useEffect, useContext} from 'react';
import Header from '../../components/header';
import {useNavigate} from "react-router-dom";
import {API, baseURL} from '../../services/api';
import axios from "axios";
import AuthContext from '../../components/shared/AuthContext';
import {useParams} from "react-router";
import {useTranslation} from "react-i18next";
import Swal from 'sweetalert2';
import OrgContext from "../../organisation/OrgContext";
import Select from "react-select";
import moment from "moment/moment";
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { PDFDownloadLink } from '@react-pdf/renderer';
import {exportQuantityHistory, quantityHistoryColumns, exportCsv} from "../../helpers/ExportCsvHelper";
import {toast, ToastContainer} from "react-toastify";

const ItemDetails = () => {
    const [t, i18n] = useTranslation();
    const {user, logout} = useContext(AuthContext);

    let allRequiredInputsAreValid = true;
    const navigate = useNavigate();

    const typeIsMarchandise = useRef();
    const typeIsService = useRef();
    const {organisation, changeOrg} = useContext(OrgContext);


    const nameInputRef = useRef();

    const buyPriceInputRef = useRef('');
    const buyPriceAccountInputRef = useRef('');
    const SalesAccountDescription = useRef('');
    const qtyInput = useRef();

    const costPriceInputRef = useRef('');
    const costPriceAccountInputRef = useRef('');
    const purchaseAccountDescription = useRef('');

    const [isNotValid, setIsNotValid] = useState('');
    const [typeChecked, setTypeChecked] = useState(true);
    const [units, setUnits] = useState([]);
    const [salesAccounts, setSalesAccounts] = useState([]);
    const [purchaseAccounts, setPurchaseAccounts] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState('');
    const [taxes, setTaxes] = useState([]);
    const [selectedTaxeVente, setSelectedTaxeVente] = useState(null);
    const [selectedTaxeAchat, setSelectedTaxeAchat] = useState('');
    const [selectedPurchaseAccount, setSelectedPurchaseAccount] = useState([]);
    const [selectedSalesAccount, setSelectedSalesAccount] = useState([]);

    const [productName, setProductName] = useState('');
    const [getUnit, setUnit] = useState();
    const [buyPrice, setBuyPrice] = useState();
    const [buyAccount, setBuyAccount] = useState();
    const [salesAccountDescription, setSalesAccountDescription] = useState();
    const [articleType, setArticleType] = useState('');

    const [purchasePrice, setPurchasePrice] = useState();
    const [purchaseAccount, setPurchaseAccount] = useState();
    const [purchaseAccountInfoDescription, setPurchaseAccountInfoDescription] = useState();
    const handleUniteChange = e => setSelectedUnit(e.target.value);

    const [taxeAchat, setTaxeAchat] = useState([]);
    const [taxeVente, setTaxeVente] = useState([]);

    const [article, setArticle] = useState([]);
    const [articleName, setArticleName] = useState("");
    const [articleQtyHistory, setArticleQtyHistory] = useState([]);
    const [qty, setQty] = useState(null);
    const [msgErrorDate, setMsgErrorDate] = useState("");
    const [proccesing, setProccessing] = useState(false);
    const [cLoaded, setCLoaded] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [allQtySelected, setAllQtySelected] = useState([]);
    const [exportcsv, setExportCsv] = useState(false);

    const {id} = useParams();
    useEffect(() => {
        getProduct();
    }, []);

    const getProduct = async (txs) => {
        setCLoaded(false);
        await axios
            .get(baseURL + `/product/get/${id}`)
            .then((response) => {
                let item = response.data.data[0];
                setArticleType(item.type);
                setArticleName(item.name);
                setArticle([item]);
                setArticleQtyHistory([item][0]["qty_history"]);
                setCLoaded(true);
            })
            .catch((error) => console.log("error while retrieving units : " + error))
    }

    const modalDateExportAllArticlesQty = async () => {
        window.$('#modalDateExportArticles').modal('show');
    }

    const exportAllArticlesQty = async () => {
        setMsgErrorDate("");
        var from_date = document.getElementById("date-from");
        var to_date = document.getElementById("date-to");
        if(from_date && to_date){
            if(from_date.value && to_date.value){
                let date1 = new Date(`${from_date.value}T00:00:00.000000Z`);
                let date2 = new Date(`${to_date.value}T23:59:59.000000Z`);
                console.log(from_date.value, to_date.value);
                if (date1 > date2) {
                    setMsgErrorDate(t("la date de fin doit être supérieure ou égal à la date de début"));
                } else  {
                    if(exportcsv){
                        let allQtys = articleQtyHistory.filter(
                            (q) => (new Date(q.created_at) >= date1 && new Date(q.created_at) <= date2)
                        );
                        let header = "Historique de la quantité de l'article: "+articleName+", entre le "+from_date.value+" et le "+to_date.value;
                        if (exportQuantityHistory(quantityHistoryColumns, allQtys,header)) {
                            window.$('#modalDateExportArticles').modal('hide');
                            toast.success('Exportation Csv générer avec succéess', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: false,
                                draggable: true,
                                progress: undefined,
                                theme: "colored",
                            });
                        } else {
                            toast.error('Une erreur s\'est produite lors de l\'exportation du fichier CSV', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: false,
                                draggable: true,
                                progress: undefined,
                                theme: "colored",
                            });
                        }

                    }else{
                        window.$('#modalDateExportArticles').modal('hide');
                        setProccessing(true);
                        setLoaded(false);
                        window.$('#modalExportArticles').modal('show');
                        let allQtys = articleQtyHistory.filter(
                            (q) => (new Date(q.created_at) >= date1 && new Date(q.created_at) <= date2)
                        );
                        setProccessing(false);
                        setLoaded(true);
                        setAllQtySelected(allQtys);
                    }
                }
            }else{
                setMsgErrorDate(t("Remplissez tous les champs"));
            }
        }

    }

    const downloadCsv = () => {
        if (articleQtyHistory && articleQtyHistory.length > 0) {
            const header = ["Date", "Mouvement", "Dépot","Quantité"];
            const data = articleQtyHistory.map(history => [
                moment(new Date(history.created_at)).format("DD/MM/YYYY"),
                history.is_init && history.is_init === 1
                    ? "Q.S.INITIAL"
                    : history.type === "achat"
                    ? "Q.ACHAT (+)"
                    : history.type === "avoir"
                    ? "Q.FACTURE D'AVOIR (+)"
                    : "Q.VENTE (-)",
                history.depot ? history.depot.name : "N/A",
                `${history.is_init && history.is_init === 1 ? "+" : history.type === "achat" || history.type === "avoir" ? "+" : "-"} ${history.qty}`
            ]);

            const fileName = `Historique_quantité_${articleName}.csv`;
            exportCsv(data, fileName, header);
        } else {
            toast.error("Aucune donnée disponible pour l'exportation", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }

    // Create styles
    const styles = StyleSheet.create({
        page: {
            // flexDirection: 'row',
            // backgroundColor: '#E4E4E4'
        },
        section: {
            margin: 10,
            padding: 10,
            fontSize: 11,
            //flex: 1,
            // flexGrow: 1,

        },
        header: {
            flexDirection: "row",
            marginBottom: 12,
            borderWidth: 1
        },
        cell: {
            borderRightWidth: 1,
            justifyContent: "center",
            alignItems: "center",
            minHeight: 25
        },
        cellRow: {
            minHeight: 25,
            padding: 5,
            paddingTop: 7
        },
        textHeader: {
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "center"
        },
        row: {
            flexDirection: "row",
        },
        textRow: {
            fontSize: 9.5
        },
        headerPage: {
            flexDirection: "row",
            padding: 5,
            borderWidth: 1.5,
            marginBottom: 5
        },
        leftSide: {
            flex: 1,
            justifyContent: "space-between"
        },
        centerContainer: {
            flex: 2,
            justifyContent: "space-between",
            alignItems: "center"
        },
        rightSide: {
            flex: 1,
            justifyContent: "flex-end",
            paddingLeft: 40
        }
    });

    // Export to PDF
    const ExportQtyHistory = ({data = []}) => {
        let date_now = new Date();
        let copyIcon = ' © ';

        let currentQty = 0;

        return(
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.section}>
                        <View style={styles.headerPage}>
                            <View style={styles.leftSide}>
                                <Text>{organisation?.name}</Text>
                                <Text>Impression provisoire</Text>
                            </View>
                            <View style={styles.centerContainer}>
                                <Text style={{textAlign: "center", fontSize: 18, fontWeight: "bold", marginBottom: 6}}>Historique des quantités</Text>
                                <View style={{flexDirection: "row"}}>
                                    <Text style={{marginRight: 30, fontSize: 11.5}}>Article</Text>
                                    <Text style={{fontSize: 11.5}}>{article && article.length > 0 ? article[0]['name'] : ""}</Text>
                                </View>
                            </View>
                            <View style={styles.rightSide}>
                                <View style={{flexDirection: "row", justifyContent: "flex-start"}}>
                                    <Text style={{textAlign: "left", marginRight: 4}}>Type : </Text>
                                    <Text style={{textAlign: "left"}}>{article && article.length > 0 ? article[0]['type'] : ""}</Text>
                                </View>
                                <View style={{flexDirection: "row", justifyContent: "flex-start"}}>
                                    <Text style={{textAlign: "left", marginRight: 4}}>Unité : </Text>
                                    <Text style={{textAlign: "left"}}>{article && article.length > 0 ? article[0]?.unit?.name : ""}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.headerPage, {border: 0, padding: 0}]}>
                            <View style={styles.leftSide}>
                                <Text style={{fontSize: 9}}>{copyIcon}<Text style={{htmlContnet: '\\00A9'}}></Text>{"ELMANAGER COMMERCIALISATION ET COMPTABILITE"}</Text>
                            </View>
                            <View style={[{justifyContent: "flex-end"}]}>
                                <View style={{flexDirection: "row", alignItems: "flex-end"}}>
                                    <Text style={{textAlign: "right", marginRight: 4}}>Date de tirage : </Text>
                                    <Text style={{textAlign: "right"}}>{date_now?.getDate()}/{date_now?.getMonth()+1}/{date_now?.getFullYear()} à {date_now?.getUTCHours()+1}:{date_now?.getMinutes() < 10 ? "0"+date_now?.getMinutes() : date_now?.getMinutes()}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.header}>
                            <View style={[styles.cell, {flex: 1}]}><Text style={styles.textHeader}>Date</Text></View>
                            <View style={[styles.cell, {flex: 3}]}><Text style={styles.textHeader}>Mouvement</Text></View>
                            <View style={[styles.cell, {flex: 3, borderRightWidth: 1}]}><Text style={styles.textHeader}>dépot</Text></View>
                            <View style={[styles.cell, {flex: 3, borderRightWidth: 0}]}><Text>Quantité</Text></View>
                        </View>
                        <View style={{border: 1,}}>
                            {

                                data?.map((history) =>
                                {

                                    currentQty = history?.is_init && history?.is_init == 1 ? currentQty + parseFloat(history.qty) : history.type === 'achat' || history.type === 'avoir' ? currentQty + parseFloat(history.qty) : currentQty - parseFloat(history.qty);
                                    return (<View key={Math.random()} style={styles.row}>
                                        <View style={[styles.cellRow, {flex: 1}]}><Text style={styles.textRow}>{moment(new Date(history.created_at)).format("DD/MM/YYYY")}</Text></View>
                                        <View style={[styles.cellRow, {flex: 3}]}><Text style={[styles.textRow, { textAlign: "center" }]}>{ history?.is_init && history?.is_init == 1 ? "Q.S.INITIAL" : history.type === 'achat' ? "Q.ACHAT (+)" : history.type === 'avoir' ? "Q.FACTURE D'AVOIR (+)" : "Q.VENTE (-)"}</Text></View>
                                        <View style={[styles.cellRow, {flex: 3, borderRightWidth: 0}]}><Text style={[styles.textRow, { textAlign: "center" }]}>{history.depot?.name}</Text></View>
                                        <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                            <Text
                                                style={[styles.textRow, {textAlign: "right"}]}>{history?.is_init && history?.is_init == 1 ? "+" : history.type === 'achat' || history.type === 'avoir' ? "+" : "-"} {history.qty}</Text>
                                        </View>
                                    </View>)
                                })
                            }

                            <View style={[styles.row, {borderTopWidth: 1}]} >
                                <View style={[styles.cellRow, {flex: 1}]}><Text style={styles.textRow}></Text></View>
                                <View style={[styles.cellRow, {flex: 3}]}><Text style={[styles.textRow, { textAlign: "center", fontWeight: "bold" }]}>Quantité actuelle</Text></View>
                                <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                    <Text style={[styles.textRow, { textAlign: "right", fontWeight: "bold" }]}>
                                        {currentQty}
                                    </Text>
                                </View>
                            </View>

                        </View>

                    </View>
                </Page>
            </Document>
        )
    }

    return (
        <>
            <ToastContainer/>
            <div className="modal fade show" id="modalDateExportArticles" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered text-center " role="document">
                    <div className="modal-content tx-size-sm">
                        <div className="modal-body text-center p-4 pb-5">
                            <h4 className="text-default tx-semibold">{t("Selection l'intervalle de temps")}</h4>
                            <div class="form-group">
                                <label htmlFor="exampleInputEmail1" className="requiredElt">{t("De")} *</label>
                                <input type="date" className="form-control" id={"date-from"} name={"date-from"}/>
                            </div>
                            <div class="form-group">
                                <label htmlFor="exampleInputEmail1" className="requiredElt">{t("à")} *</label>
                                <input type="date" className="form-control" id={"date-to"} name={"date-to"}/>
                            </div>
                            {msgErrorDate && msgErrorDate.length > 0 ? (<div class="alert alert-danger" role="alert">
                                <p>{msgErrorDate}</p>
                            </div>) : null}
                            <button
                                className='btn btn-success pd-x-25'
                                style={{height: 38}}
                                onClick={exportAllArticlesQty}
                            >{t("Exporter")}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade show" id="modalExportArticles" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered text-center " role="document">
                    <div className="modal-content tx-size-sm">
                        {proccesing ? (<div className="modal-body text-center p-4 pb-5">
                            <i className="icon icon-clock fs-70 text-warning lh-1 my-5 d-inline-block"></i>
                            <h4 className="text-warning tx-semibold">{t("Traitement en cours!")}</h4>
                            <p className="mg-b-20 mg-x-20">{t("Patientez s'il-vous-plait")}</p>
                        </div>) : null}
                        {loaded ? (<div className="modal-body text-center p-4 pb-5">
                            <i className="icon icon-check fs-70 text-success lh-1 my-5 d-inline-block"></i>
                            <h4 className="text-success tx-semibold">{t("Généré avec succès!")}</h4>
                            <PDFDownloadLink
                                document={<ExportQtyHistory data={[...allQtySelected]}/>}
                                fileName={`Historique de la quantité -${article && article.length > 0 ? article[0]['name'] : ""}.pdf`}
                                className='btn btn-success pd-x-25'
                                style={{height: 38}}
                            >

                                {({blob, url, loading, error}) =>
                                    loading ? t("Loading document...") : <><span
                                        className="fe fe-download"> </span> {t("Exporter")}</>
                                }
                            </PDFDownloadLink>

                        </div>) : null}
                    </div>
                </div>
            </div>


            <div className="main-container container-fluid">
                <div className="page-header">
                    <h1 className="page-title">Detail de l'article</h1>
                    <div>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="javascript:void(0)"
                                                               onClick={() => navigate('/items/list')}>Liste des
                                articles</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">details de l'article</li>
                        </ol>
                    </div>
                </div>

                <div className="col-md-12" style={{display: cLoaded ? 'none' : 'block'}}>
                    <center>
                        <div class="spinner-border text-primary me-2" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </center>
                </div>

                <div className="row" style={{display: !cLoaded ? 'none' : 'flex'}}>
                    <div
                        className={articleType === 'Services' ? "col-lg-12 col-md-12 col-sm-12" : "col-lg-12 col-md-12 col-sm-12 col-xl-8"}>
                        <div className="card cart">
                            <div className="card-header">
                                <h3 class="card-title">{t('Information générale')}</h3>
                            </div>
                            {
                                article.map((article) => {
                                    return (
                                        <div className="card-body">
                                            <h3 class="mb-3 fw-semibold">{article.name}</h3>
                                                            {/* Affichage de l'image */}
                {article.path_image && (
                    <div className="mb-4">
                        <img
                            src={`${baseURL.replace("/api", "")}/storage/${article.path_image}`} // URL complète de l'image
                            alt={article.name}
                            style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
                        />
                    </div>
                )}
                                            <div><span class="fw-bold me-2">Type :</span><span
                                                class="fw-bold text-primary">{article.type}</span></div>
                                            <div style={{display: article.type === 'Services' ? 'none' : 'block'}}><span
                                                class="fw-bold me-2">Unité :</span><span
                                                class="fw-bold text-success">{article.unit.name}</span></div>
                                            <div hidden={ articleType === 'Services' }><span class="fw-bold me-2">Quantité :</span><span
                                                class="fw-bold text-success">{article.qty} article</span></div>

                                            <div className="infosVente">
                                                <br/>
                                                <h4 class="mb-5 mt-3 fw-bold">Informations sur les ventes :</h4>

                                                <div class="table-responsive">
                                                    <table className="table table-bordered">
                                                        <tbody>
                                                        <tr hidden={ articleType === 'Services' }>
                                                            <td className="fw-bold">Prix de vente</td>
                                                            <td>{article.sellingPrice}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-bold">Compte</td>
                                                            <td>{article.sales_account.name + ' - ' + article.sales_account.code}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-bold">Description</td>
                                                            <td>{article.sellingInfosDescription}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-bold">Taxe</td>
                                                            <td>{article.taxe_vente.name}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div className="infosVente">
                                                <br/>
                                                <h4 class="mb-5 mt-3 fw-bold">Informations sur les achats :</h4>

                                                <div class="table-responsive">
                                                    <table className="table table-bordered">
                                                        <tbody>
                                                        <tr hidden={ articleType === 'Services' }>
                                                            <td className="fw-bold">Prix de revient</td>
                                                            <td>{article.costPrice}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-bold">Compte</td>
                                                            <td>{article.purchase_account.name + ' - ' + article.purchase_account.code}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-bold">Description</td>
                                                            <td>{article.purchaseInfosDescription}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-bold">Taxe</td>
                                                            <td>{article.taxe_achat.name}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                    {article[0] && article[0]?.type != "Services" ? (
                        <div className="col-lg-12 col-xl-4 col-sm-12 col-md-12">
                            <div class="card">
                                <div class="card-header" style={{justifyContent: "space-between"}}>
                                    <div class="card-title">{t('Historique de la quantité')}</div>
                                    <div>
                                        {articleQtyHistory && articleQtyHistory.length > 0 ? (
                                            <>
                                                <button
                                                    onClick={modalDateExportAllArticlesQty}
                                                    className='btn-sm btn-info'
                                                    style={{height: 38}}
                                                > {t("Exporter PDF ")}<i class="fa fa-file-pdf-o"></i>
                                                </button>
                                                <br/>
                                                <br/>
                                                <button
                                                    onClick={downloadCsv}
                                                    className='btn-sm btn-info'
                                                    style={{height: 38}}
                                                > {t("Exporter CSV ")}<i class="fa fa-table"></i>
                                                </button>
                                            </>
                                        ) : null}
                                    </div>
                                </div>
                                <div class="card-body py-2">
                                    <div class="table-responsive setMaxHeight">
                                        <table className="table table-borderless text-nowrap mb-0">
                                            <tbody>
                                            {
                                                articleQtyHistory.map((history) => {
                                                    return (
                                                        history.type === 'achat' || history.type === 'avoir' ?
                                                            <tr>
                                                                <td className="text-start">{moment(history.created_at).format("DD/MM/YYYY")}</td>
                                                                <td className="text-end"><span
                                                                    class="fw-bold text-success">+ {history.qty} {history.is_init === 1 ? '(initialisation de la qunatité)' : ''} {history.type === 'avoir' ? '(Suite à une Facture d\'avoir)' : ''}</span>
                                                                </td>
                                                            </tr>
                                                            :
                                                            <tr>
                                                                <td className="text-start">{moment(history.created_at).format("DD/MM/YYYY")}</td>
                                                                <td className="text-end"><span
                                                                    class="fw-bold text-danger">- {history.qty}</span>
                                                                </td>
                                                            </tr>
                                                    );
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>) : null}
                </div>
            </div>
        </>
    );
}
export default ItemDetails;